var _rect, _rect2, _rect3, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYogaActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 3,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 3,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 3,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1C18.3431 1 17 2.34315 17 4V20C17 18.3431 18.3431 17 20 17C21.6569 17 23 18.3431 23 20V4C23 2.34315 21.6569 1 20 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C16 20.5523 16.4477 21 17 21C17.5523 21 18 20.5523 18 20H16ZM22 20C22 20.5523 22.4477 21 23 21C23.5523 21 24 20.5523 24 20H22ZM18 4C18 2.89543 18.8954 2 20 2V0C17.7909 0 16 1.79086 16 4H18ZM18 20V4H16V20H18ZM18 20C18 18.8954 18.8954 18 20 18V16C17.7909 16 16 17.7909 16 20H18ZM20 18C21.1046 18 22 18.8954 22 20H24C24 17.7909 22.2091 16 20 16V18ZM22 4V20H24V4H22ZM20 2C21.1046 2 22 2.89543 22 4H24C24 1.79086 22.2091 0 20 0V2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6H1V23H20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaActive);
export default __webpack_public_path__ + "static/media/yoga-active.d428b244b20e2f1bb788a7ccdd2ed510.svg";
export { ForwardRef as ReactComponent };